module.exports = __webpack_public_path__ + "static/media/21-WaterHeatExchanger - DX cool - Water heat.c5f8a075.png";